import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { isEmpty } from '../../utils/lang.js';
import { Button } from '../Button/Button.js';
import { ButtonMenu } from '../ButtonMenu/ButtonMenu.js';
import { IconMore } from '../Icons/IconMore.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var BtnGroup = styled.div.withConfig({
  displayName: "ActionBtnGroup__BtnGroup",
  componentId: "sc-1fcg2uq-0"
})(["&&{display:flex;align-items:flex-start;}&& > button{line-height:0;align-self:auto;}&& > button:last-of-type{margin:0;}"]);

function ActionBtnGroup(_ref) {
  var primaryActions = _ref.primaryActions,
      secondaryActions = _ref.secondaryActions;

  var _useThemeContext = useThemeContext(),
      localization = _useThemeContext.localization;

  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
      t = _useTranslations.t;

  if (isEmpty(primaryActions) && isEmpty(secondaryActions)) {
    return null;
  }

  if (primaryActions && primaryActions.length > 2) {
    console.error("%cEntity warning!\nc%At most 2 primary action buttons are supported.", "font-weight: bold;", "");
  }

  return /*#__PURE__*/jsxs(BtnGroup, {
    role: "group",
    children: [primaryActions === null || primaryActions === void 0 ? void 0 : primaryActions.map(function (a, i) {
      return /*#__PURE__*/jsx(Tooltip, {
        content: a.label,
        variant: "dark",
        size: "sm",
        children: /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, a), {}, {
          variant: "ghost",
          hideLabel: true
        }))
      }, "primary_" + i);
    }), secondaryActions && Array.isArray(secondaryActions === null || secondaryActions === void 0 ? void 0 : secondaryActions.options) ? /*#__PURE__*/jsx(ButtonMenu, {
      options: secondaryActions === null || secondaryActions === void 0 ? void 0 : secondaryActions.options,
      buttonProps: {
        disabled: secondaryActions === null || secondaryActions === void 0 ? void 0 : secondaryActions.disabled,
        label: t("CommentRow.moreActions"),
        hideLabel: true,
        startAdornment: IconMore,
        variant: "ghost"
      },
      tooltipProps: {
        content: t("CommentRow.moreActions"),
        position: "bottom"
      },
      onActivate: secondaryActions === null || secondaryActions === void 0 ? void 0 : secondaryActions.onActivate
    }) : null]
  });
}

ActionBtnGroup.propTypes = {
  "primaryActions": _PropTypes.arrayOf(_PropTypes.object),
  "secondaryActions": _PropTypes.shape({
    "disabled": _PropTypes.bool,
    "onActivate": _PropTypes.func,
    "options": _PropTypes.arrayOf(_PropTypes.object).isRequired
  })
};
ActionBtnGroup.displayName = "ActionBtnGroup";

export { ActionBtnGroup };
